import './App.css';
import { RouterProvider } from 'react-router-dom';
import { routerItems } from './utils/routers';

function App() {
  return (
    <div className="App">
      <RouterProvider router={routerItems} />
    </div>
  );
}

export default App;
